<script>
// import ChangePwd from "@/components/userinfo/ChangePwd.vue";
// import weekStr from "@/common/weekStr.js";
export default {
  //   components: {
  //     ChangePwd
  //   },
  data() {
    // const ROLE_COMPLIANCE =
    //   localStorage.getItem("roles").indexOf("ROLE_COMPLIANCE") > -1;
    const loginPhone = this.$cookie.get("username");
    return {
      confirmLoginDialog: false,
      loginPhone,
      loginUserPwd: undefined,
      type: undefined
    };
  },
  computed: {
    mobilePhone() {
      if (this.loginPhone) {
        const mobile =
          this.loginPhone.substr(0, 3) + "****" + this.loginPhone.substr(7);
        return mobile;
      } else {
        return "--";
      }
    }
  },
  methods: {
    async submitForm(type) {
      let result = await this.$http.checkAdminPwd(this.loginUserPwd);
      if (result == "success") {
        if (this.type === "phone") {
          this.$router.push({
            path: `${this.$route.path}/updaetUserInfo/${this.type}`
          });
        } else if (this.type === "password") {
          this.$router.push({
            path: `${this.$route.path}/updaetUserInfo/${this.type}`
          });
        }
      } else {
        this.$message.warning("密码错误，请重新输入密码");
      }
    },
    closeForm() {
      this.confirmLoginDialog = false;
      this.loginUserPwd = undefined;
      this.type = undefined;
    },
    onClickUpdate(type) {
      this.type = type;
      this.confirmLoginDialog = true;
    }
  }
};
</script>

<template>
  <div class="UserInfoIndex">
    <div class="userInfoView">
      <span class="userInfoTitle">手机账号</span>
      <span class="userInfoContent">当前手机号为 {{mobilePhone}}</span>
      <span class="userInfoButton">
        <el-button
          type="primary"
          class="operationButton"
          size="small"
          @click="onClickUpdate('phone')"
        >更换</el-button>
      </span>
    </div>
    <div class="userInfoView">
      <span class="userInfoTitle">登录密码</span>
      <span class="userInfoContent">密码要求长度超过6位，建议您经常修改密码，以保证帐号更加安全。</span>
      <span class="userInfoButton">
        <el-button
          type="primary"
          class="operationButton"
          size="small"
          @click="onClickUpdate('password')"
        >修改</el-button>
      </span>
    </div>
    <Dialog
      v-if="confirmLoginDialog"
      btn-text="确 定"
      title="请输入本账户密码"
      @confirm="submitForm()"
      @close="closeForm"
    >
      <el-input v-model="loginUserPwd" show-password class="confrimDialogInput" placeholder="输入密码"></el-input>
    </Dialog>
  </div>
</template>

<style lang="scss" scoped>
// @import "@/css/color.scss";

.UserInfoIndex {
  padding: 29px 26px 29px 29px;
  .userInfoView {
    margin-left: 10px;
    padding-top: 15px;
    // line-height: 60px;
    .userInfoTitle {
      display: inline-block;
      width: 100px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(162, 164, 166, 1);
      line-height: 25px;
      vertical-align: top;
    }
    .userInfoContent {
      display: inline-block;
      width: 383px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(89, 94, 122, 1);
      line-height: 25px;
    }
    .userInfoButton {
      vertical-align: top;
      display: inline-block;
      .operationButton {
        background-color: #00c1de;
        border-color: #00c1de;
      }
    }
  }
  .confrimDialogInput {
    width: 300px;
    margin: 0 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userinfo/index.vue